<template>
  <div>
    <MemberLayout>
      <div class="container" v-if="!isLoading">
        <form @submit.prevent="navigateToNext">
          <div class="card my-3">
            <div class="card-header bg-primary text-white">寄送資料</div>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                <div class="form-group">
                  <label for="">寄送方式</label>
                  <select class="form-control">
                    <option value="宅急便">宅急便</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="">配送地址</label>
                  <select
                    @change="changeAddressType($event)"
                    class="form-control"
                  >
                    <option value="" disabled selected>選擇配送地址</option>
                    <option value="預設">預設</option>
                    <option value="自訂">自訂</option>
                  </select>
                </div>
              </li>
              <li class="list-group-item">
                <div class="form-group">
                  <label for="">收件人</label>
                  <input
                    type="text"
                    v-model="receiveName"
                    placeholder="請輸入收件人"
                    class="form-control"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="">聯絡電話</label>
                  <input
                    type="text"
                    v-model="tel"
                    placeholder="請輸入聯絡電話"
                    class="form-control"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="">郵遞區號</label>
                  <input
                    type="text"
                    v-model="zip"
                    placeholder="EX:10488"
                    class="form-control"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="">縣市地區</label>
                  <input
                    type="text"
                    v-model="address1"
                    placeholder="EX:台北市中山區"
                    class="form-control"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="">地址</label>
                  <input
                    type="text"
                    v-model="address2"
                    placeholder="請輸入地址"
                    class="form-control"
                    required
                  />
                </div>
              </li>
            </ul>
          </div>

          <div class="card my-3">
            <div class="card-header bg-primary text-white">訂購商品總覽</div>
            <ul class="list-group list-group-flush">
              <li
                v-for="(item, itemName) in cart.items"
                :key="itemName"
                class="list-group-item"
              >
                <div>
                  <h4>
                    {{ giveawayHint(item.SAMPLEFLG) }}{{ item.data.NAME }}
                  </h4>
                  <p>$ {{ item.data.UNITPRICE }} NTD x {{ item.amount }}件</p>
                </div>
              </li>
              <li class="list-group-item">
                <h4>總計：{{ regularSummation }}</h4>
              </li>
            </ul>
          </div>

          <div class="form-group">
            <button type="submit" class="btn btn-warning btn-block">
              確認進入付款頁
            </button>
          </div>
        </form>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
import db from "../../api/db";
import MemberLayout from "../../components/member/MemberLayout";
export default {
  name: "OrderSummationScreen",
  components: {
    MemberLayout,
  },
  computed: {
    regularSummation() {
      const vm = this;
      const { cart } = vm;
      let regularSummation = 0;
      for (let x in cart.items) {
        regularSummation += cart.items[x].data.UNITPRICE * cart.items[x].amount;
      }
      return regularSummation;
    },
  },
  data() {
    return {
      cart: { user: {}, items: [], updatedAt: new Date() },
      deliverType: "宅急便",
      addressType: "",
      address1: "",
      address2: "",
      receiveName: "",
      tel: "",
      zip: "",
      isSendingForm: false,
      hasCheckGiveaway: false,
      isLoading: true,
    };
  },
  methods: {
    giveawayHint(isGiveaway) {
      return isGiveaway === 1 ? "[贈品]" : "";
    },
    changeAddressType($event) {
      const vm = this;
      const value = $event.target.value;
      if (value == "預設") {
        vm.setDefaultAddress();
      }
      vm.addressType = value;
    },
    setDefaultAddress() {
      const vm = this;
      const { cart } = vm;
      // TODO: 與品超確認是dispatch獲釋docSend
      const addressKey = cart.user.dispatch;
      db.doc(`jaddressmasterout/${addressKey}`)
        .get()
        .then((doc) => {
          if (!doc.exists) {
            alert("發生錯誤,尚未設定預設地址");
            return;
          }
          const address = doc.data();
          if (address.STATUS !== 1) {
            alert("發生錯誤,尚未設定預設地址");
            return;
          }

          vm.zip = address.ZIP;
          vm.tel = address.TEL;
          vm.receiveName = address.NAME;
          vm.address1 = address.ADDRESS1;
          vm.address2 = address.ADDRESS2;
        })
        .catch((err) => {
          console.log("err", err);
          alert("尚未設定預設地址");
        });
    },
    navigateToNext() {
      const vm = this;
      const {
        cart,
        deliverType,
        addressType,
        receiveName,
        tel,
        zip,
        address1,
        address2,
      } = vm;
      const newCart = { ...cart };
      newCart.deliver = {
        deliverType: deliverType,
        addressType: addressType,
        receiveName: receiveName,
        tel: tel,
        zip: zip,
        address1: address1,
        address2: address2,
      };
      // TODO: OrderSummationScreen:228
      // 將newCart存到Firebase
      db.collection("appCarts")
        .add(newCart)
        .then((docRef) => {
          const cartDocId = docRef.id;
          vm.isSendingForm = false;
          vm.$router.push({
            name: "OrderPaymentScreen",
            params: { cartDocId },
          });
        })
        .catch((err) => {
          console.log("err", err);
          vm.isSendingForm = false;
          alert("發生錯誤", "請確保裝置網路正常連線並再嘗試一次。");
        });
    },
  },
  mounted() {
    const vm = this;
    async function fetchData() {
      const { hasCheckGiveaway } = vm;
      const cart = vm.$route.params["cart"];
      // 檢查㽪品
      if ("SALESTYPE" in cart && !hasCheckGiveaway) {
        vm.hasCheckGiveaway = true;
        const businessMonth = cart.businessMonth;
        const SALESTYPE = cart.SALESTYPE;
        // 如果是定期購買
        if (SALESTYPE == 1) {
          // 取得使用者的COURSE
          const COURSE = cart.user.COURSE;
          const giveawayDocList = await db
            .collection("jcombinationout")
            .where("COURSE", "==", COURSE)
            // 營業月份 '202010' => '10', '202011' => '11'
            .where("MONTH_TYPE", "==", `${businessMonth[4]}${businessMonth[5]}`)
            // 而且是贈品
            .where("SAMPLEFLG", "==", 1)
            .get();
          const giveawayCodeList = [];

          giveawayDocList.forEach((doc) => {
            const giveaway = doc.data();
            giveawayCodeList.push(giveaway.ITEMCODE);
          });

          // 另外去取得 http://api.fordays.com.tw:5050/api/jsellgiftout
          // 放到分 giveawayDocList 去
          const jsellgiftoutRes = await vm.axios.post(
            "https://fordays-backend-official.herokuapp.com/member/jsellgiftout",
            {
              SEQID: cart.SEQ,
              MONTH: cart.businessMonth,
              SALESTYPE: 1,
              RECEIPTDATE: cart.receptDate,
            }
          );
          const jsellgiftoutArray = jsellgiftoutRes.data.Value;

          jsellgiftoutArray.forEach((gift) => {
            giveawayCodeList.push(gift.ITEMCODE);
          });

          const giveawayPromise = giveawayCodeList.map((itemCode) => {
            return db.collection("jitemout").doc(itemCode).get();
          });
          const giveawayItemDocs = await Promise.all(giveawayPromise);
          // 贈品詳情查詢集合表
          const giveawayTable = {};
          giveawayItemDocs.forEach((doc) => {
            const giveaway = doc.data();
            const id = doc.id;
            giveawayTable[id] = giveaway;
          });
          // 將贈品整理成正確的購物車格式放置在購物車中
          giveawayDocList.forEach((doc) => {
            const giveaway = doc.data();
            const giveawayDetails = giveawayTable[giveaway.ITEMCODE];
            const giveawayItem = {
              COURSE: giveaway.COURSE,
              ID: giveaway.ID,
              ITEMCODE: giveaway.ITEMCODE,
              SALESTYPE: SALESTYPE,
              amount: giveaway.NET,
              // 贈品 BMUNITPRICE, UNITPRICE 都是 0
              data: {
                BMUNITPRICE: 0,
                CODE: giveaway.ITEMCODE,
                ITEMGROUP: giveawayDetails.ITEMGROUP,
                MultipyNet: giveawayDetails.MultipyNet,
                NAME: giveawayDetails.NAME,
                STOCKFLG: giveawayDetails.STOCKFLG,
                UNITPRICE: 0,
                updatedAt: giveaway.updatedAt,
              },
              isChecked: true,
              // 是贈品
              SAMPLEFLG: 1,
            };
            const cartItemsLength = Object.keys(cart.items).length;
            cart.items[`${cartItemsLength + 1}`] = giveawayItem;
          });

          // 條件式的贈品
          jsellgiftoutArray.forEach((giveaway) => {
            const giveawayDetails = giveawayTable[giveaway.ITEMCODE];
            const giveawayItem = {
              // COURSE: giveaway.COURSE,
              // ID: giveaway.ID,
              ITEMCODE: giveaway.ITEMCODE,
              SALESTYPE: SALESTYPE,
              amount: giveaway.NET,
              // 贈品 BMUNITPRICE, UNITPRICE 都是 0
              data: {
                BMUNITPRICE: 0,
                CODE: giveaway.ITEMCODE,
                ITEMGROUP: giveawayDetails.ITEMGROUP,
                MultipyNet: giveawayDetails.MultipyNet,
                NAME: giveawayDetails.NAME,
                STOCKFLG: giveawayDetails.STOCKFLG,
                UNITPRICE: 0,
                // updatedAt: giveaway.updatedAt,
              },
              isChecked: true,
              // 是贈品
              SAMPLEFLG: 1,
            };
            const cartItemsLength = Object.keys(cart.items).length;
            cart.items[`${cartItemsLength + 1}`] = giveawayItem;
          });

          vm.cart = cart;
          vm.isLoading = false;
        } else {
          vm.cart = cart;
          vm.isLoading = false;
        }
      } else {
        vm.cart = cart;
        vm.isLoading = false;
      }
    }
    fetchData();
  },
};
</script>
<style lang="scss" scoped>
</style>